// Extensions.jsx
import React, { useState, useMemo, useRef, useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { __ } from '@wordpress/i18n';
import iziToast from 'izitoast';

const SearchIcon = ({ className }) => (
    <svg width="21" height="21" className={className} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.875 14.875L18.375 18.375" stroke="#98989A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.625 9.625C16.625 5.759 13.491 2.625 9.625 2.625C5.759 2.625 2.625 5.759 2.625 9.625C2.625 13.491 5.759 16.625 9.625 16.625C13.491 16.625 16.625 13.491 16.625 9.625Z" stroke="#98989A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const CheckIcon = ({ className }) => (
    <svg width="18" height="18" className={className} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.25 1.84335C10.5397 1.62026 9.7839 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 8.2161 16.3797 7.46028 16.1567 6.75" stroke="#98989A" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M6.375 7.125L9 9.75L15.7502 2.25" stroke="#98989A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const iconHtml = ReactDOMServer.renderToStaticMarkup(
    <CheckIcon className="checkmark-circle" />
);

const renderExtensionIcon = (key) => {
    switch (key) {
        case 'cross-domain-copy-paste':
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
            );
        case 'header-footer-builder':
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2"></rect>
                    <line x1="3" y1="9" x2="21" y2="9"></line>
                    <line x1="3" y1="15" x2="21" y2="15"></line>
                </svg>
            );
        case 'mega-menu-builder':
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <line x1="3" y1="6" x2="21" y2="6"></line>
                    <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
            );
        case 'widget-builder':
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="16 18 22 12 16 6"></polyline>
                    <polyline points="8 6 2 12 8 18"></polyline>
                </svg>
            );
        case 'conditional-content':
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
            );
        case 'advanced-sticky':
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2a8 8 0 0 0-8 8v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a8 8 0 0 0-8-8z"></path>
                    <line x1="12" y1="18" x2="12" y2="22"></line>
                </svg>
            );
        case 'advanced-parallax':
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="5 9 2 12 5 15"></polyline>
                    <polyline points="9 5 12 2 15 5"></polyline>
                    <polyline points="15 19 12 22 9 19"></polyline>
                    <polyline points="19 9 22 12 19 15"></polyline>
                </svg>
            );
        case 'image-masking':
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
                    <path d="M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12z"></path>
                </svg>
            );
        case 'advanced-tooltip':
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
            );
        default:
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22v-4h3a2 2 0 0 0 2-2v-3a2.5 2.5 0 0 1 0-5V5a2 2 0 0 0-2-2h-3a2.5 2.5 0 0 1-5 0H5a2 2 0 0 0-2 2v3a2.5 2.5 0 0 1 0 5v3a2 2 0 0 0 2 2h3a2.5 2.5 0 0 1 5 0z" />
                </svg>
            );
    }
};

const Extensions = ({
    extensionsData,
    enabledExtensions,
    setEnabledExtensions,
    loading
}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filterType, setFilterType] = useState('all');
    const [menuOpen, setMenuOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const filteredExtensions = useMemo(() => {
        const allExts = extensionsData.all || {};
        if (Object.keys(allExts).length === 0) return {};

        const lowerQuery = searchQuery.toLowerCase();
        let result = {};

        for (const [categoryName, categoryExts] of Object.entries(allExts)) {
            let filteredCategory = {};

            for (const [key, data] of Object.entries(categoryExts)) {
                // Filter by type
                if (filterType === 'free' && data.is_pro) continue;
                if (filterType === 'pro' && !data.is_pro) continue;

                if (data.title.toLowerCase().includes(lowerQuery) || data.desc.toLowerCase().includes(lowerQuery)) {
                    filteredCategory[key] = data;
                }
            }

            if (Object.keys(filteredCategory).length > 0) {
                result[categoryName] = filteredCategory;
            }
        }

        return result;
    }, [extensionsData.all, searchQuery, filterType]);

    const handleToggle = (key, isChecked) => {
        let newEnabled;
        if (isChecked) {
            newEnabled = [...enabledExtensions, key];
        } else {
            newEnabled = enabledExtensions.filter(item => item !== key);
        }
        setEnabledExtensions(newEnabled);
        handleSaveExtensions(newEnabled);
    };

    const handleBulkAction = (action) => {
        const isProActive = !!window.thhaAdminSettings.is_pro_active;
        const allKeys = Object.values(extensionsData.all)
            .flatMap(category => Object.entries(category))
            .filter(([key, data]) => (data.status === 'available' || (key === 'cross-domain-copy-paste' && isProActive)))
            .map(([key]) => key);
        
        let newEnabled;
        if (action === 'enable') {
            newEnabled = Array.from(new Set(allKeys));
        } else if (action === 'disable') {
            newEnabled = [];
        }
        setEnabledExtensions(newEnabled);
        handleSaveExtensions(newEnabled);
    };

    const handleSaveExtensions = (extsToSave) => {
        setIsSaving(true);
        const formData = new FormData();
        formData.append('action', 'thha_save_extensions_ajax');
        formData.append('_wpnonce', window.thhaAdminSettings.saveNonce);
        extsToSave.forEach(key => {
            formData.append('enabled_extensions[]', key);
        });

        fetch(window.thhaAdminSettings.ajaxurl, {
            method: 'POST',
            body: formData,
        })
        .then(res => {
            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
        })
        .then(response => {
            if (response.success) {
                iziToast.show({
                    id: 'success-toast',
                    message: __('Extensions settings saved successfully!', 'huge-addons-for-elementor'),
                    position: 'topRight',
                    backgroundColor: '#FFFFFF',
                    messageColor: '#19192C',
                    messageSize: '16',
                    messageLineHeight: '24',
                    iconUrl: `data:image/svg+xml;utf8,${encodeURIComponent(iconHtml)}`,
                    displayMode: 0,
                    close: true,
                    closeColor: '#98989A',
                    imageWidth: 50,
                    maxWidth: 400,
                    layout: 2,
                    transitionIn: 'fadeInDown',
                    theme: 'light',
                    progressBarColor: '#22C55E',
                    boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)',
                });
            } else {
                throw new Error(response.data || 'Unknown server error');
            }
        })
        .catch((error) => {
            console.error('Error saving extensions:', error);
            iziToast.error({
                title: 'ERROR',
                message: `Extensions updating failed: ${error.message}`,
                position: 'topCenter',
                timeout: 5000
            });
        })
        .finally(() => {
            setIsSaving(false);
        });
    };

    if (loading) return <div className="widgets-section loading">{__('Loading Extensions...', 'huge-addons-for-elementor')}</div>;

    const isProActive = !!window.thhaAdminSettings.is_pro_active;

    return (
        <div className="widgets-section">
            <div className="section-header">
                <div className="header-left">
                    <h1 className="title">{__('Extensions', 'huge-addons-for-elementor')}</h1>
                    <div className="search-container">
                        <SearchIcon className="search-icon" />
                        <input
                            type="text"
                            className="search-field"
                            placeholder={__('Search Extension', 'huge-addons-for-elementor')}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                </div>

                <div className="header-right">
                    <div className="actions">
                        <button 
                            type="button" 
                            className="disable-btn"
                            onClick={() => handleBulkAction('disable')}
                        >
                            {__('Disable', 'huge-addons-for-elementor')}
                        </button>
                        <button 
                            type="button" 
                            className="enable-all-btn"
                            onClick={() => handleBulkAction('enable')}
                        >
                            {__('Enable All', 'huge-addons-for-elementor')}
                        </button>
                        <div className="menu-dropdown-container" ref={dropdownRef}>
                            <button
                                type="button"
                                className={`menu-btn ${menuOpen ? 'active' : ''}`}
                                onClick={() => setMenuOpen(!menuOpen)}
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="3" y1="12" x2="21" y2="12"></line>
                                    <line x1="3" y1="6" x2="21" y2="6"></line>
                                    <line x1="3" y1="18" x2="21" y2="18"></line>
                                </svg>
                            </button>
                            {menuOpen && (
                                <div className="menu-dropdown">
                                    <div className="dropdown-label">{__('Filter Extensions', 'huge-addons-for-elementor')}</div>
                                    <button
                                        type="button"
                                        className={`dropdown-item ${filterType === 'free' ? 'active' : ''}`}
                                        onClick={() => {
                                            setFilterType(filterType === 'free' ? 'all' : 'free');
                                            setMenuOpen(false);
                                        }}
                                    >
                                        <span>{__('Free', 'huge-addons-for-elementor')}</span>
                                        {filterType === 'free' && (
                                            <span className="checkmark">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                </svg>
                                            </span>
                                        )}
                                    </button>
                                    <button
                                        type="button"
                                        className={`dropdown-item ${filterType === 'pro' ? 'active' : ''}`}
                                        onClick={() => {
                                            setFilterType(filterType === 'pro' ? 'all' : 'pro');
                                            setMenuOpen(false);
                                        }}
                                    >
                                        <span>{__('Pro', 'huge-addons-for-elementor')}</span>
                                        {filterType === 'pro' && (
                                            <span className="checkmark">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                </svg>
                                            </span>
                                        )}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Form wrapping for SCSS selection mapping */}
            <form onSubmit={(e) => e.preventDefault()}>
                <div className="thha-widget-grid">
                    {Object.entries(filteredExtensions || {}).map(([categoryName, extensionsObjects]) => {
                        if (!extensionsObjects || Object.keys(extensionsObjects).length === 0) return null;

                        return (
                            <div key={categoryName} className="widget-category-group">
                                <h2 className="widget-category-title">{categoryName}</h2>
                                <div className="widget-cards-container" style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}>
                                    {Object.entries(extensionsObjects)
                                        .sort((a, b) => a[1].title.localeCompare(b[1].title))
                                        .map(([key, data]) => {
                                        const isEnabled = enabledExtensions.includes(key);
                                        const typeClass = data.is_pro ? 'pro' : 'free';
                                        const isAvailable = (data.status === 'available') || (key === 'cross-domain-copy-paste' && isProActive);

                                        return (
                                            <div key={key} className={`thha-widget-card ${typeClass} ${isAvailable ? 'available' : data.status}`}>
                                                <div className="row" style={{ width: '100%' }}>
                                                    {/* Extension Icon */}
                                                    <div className="thha-widget-icon" style={{ color: '#00D4FF' }}>
                                                        {renderExtensionIcon(key)}
                                                    </div>

                                                    {/* Toggle Switch */}
                                                    {isAvailable ? (
                                                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                            {data.is_pro && <span className="pro-badge">pro</span>}
                                                            <label className="thha-toggle-switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isEnabled}
                                                                    onChange={(e) => handleToggle(key, e.target.checked)}
                                                                />
                                                                <span className="thha-slider"></span>
                                                            </label>
                                                        </div>
                                                    ) : (
                                                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                            {!isProActive ? (
                                                                <span className="pro-badge">pro</span>
                                                            ) : (
                                                                <span className="upcoming-badge">UPCOMING</span>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Extension Info */}
                                                <div className="thha-widget-info" style={{ width: '100%', textAlign: 'center', marginTop: '10px' }}>
                                                    <div className="thha-widget-title" style={{ justifyContent: 'center' }}>
                                                        {data.title}
                                                    </div>
                                                    <div className="thha-widget-desc" style={{ fontSize: '11px', color: '#6b7280', marginTop: '5px', lineHeight: '1.3' }}>
                                                        {data.desc}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </form>
        </div>
    );
};

export default Extensions;
